import React, { createContext, useCallback } from "react";
import PropTypes from "prop-types";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";

/**
 * Contains the features that are currently enabled
 */
export const FeaturesContext = createContext({
  /** whether the features are currently loading */
  loading: true,
  /** whether an error occurred while loading the features */
  error: false,
  /** an object containing key-value pairs of features and whether they are currently enabled, defaults to null*/
  features: null,
  /** a function to check if a given feature is enabled */
  hasFeature: _feature => false,
  /** a function to check if given features are enabled */
  hasFeatures: _features => false,
  /** a function to refetch the features from the api */
  refetchFeatures: () => {}
});
FeaturesContext.displayName = "FeaturesContext";

/** Sets up the features context by fetching from the api */
export const FeaturesProvider = ({ children }) => {
  const {
    loading: featuresLoading,
    error: featuresError,
    response: featuresResponse,
    refetch: refetchFeatures
  } = useFetchGetV2("settings/features");

  // TODO: Remove this function when all converted to using hasFeatures
  const hasFeature = useCallback(
    feature => {
      return featuresResponse && featuresResponse[feature];
    },
    [featuresResponse]
  );

  const hasFeatures = useCallback(
    features => {
      return (
        featuresResponse && features.every(feature => featuresResponse[feature])
      );
    },
    [featuresResponse]
  );

  return (
    <FeaturesContext.Provider
      value={{
        loading: featuresLoading,
        error: featuresError,
        features: featuresResponse ?? [],
        hasFeature,
        hasFeatures,
        refetchFeatures
      }}
    >
      {children}
    </FeaturesContext.Provider>
  );
};

FeaturesProvider.propTypes = {
  children: PropTypes.node
};
